import { render, staticRenderFns } from "./UserRegister2.vue?vue&type=template&id=05892c70&scoped=true"
import script from "./UserRegister2.vue?vue&type=script&lang=js"
export * from "./UserRegister2.vue?vue&type=script&lang=js"
import style0 from "./UserRegister2.vue?vue&type=style&index=0&id=05892c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05892c70",
  null
  
)

export default component.exports